// Mock data store para simular persistencia durante la sesión
let mockWines = [
  {
    id: '1',
    name: 'Marqués de Riscal Reserva',
    description: 'Un vino tinto elegante con notas de frutas maduras y especias.',
    price: 25.99,
    imageUrl: '/images/wines/marques-riscal.jpg',
    categoryId: '1',
    wineryId: '1',
    type: 'Tinto',
    year: 2018,
    alcoholContent: 13.5,
    stock: 50
  },
  {
    id: '2',
    name: 'Vega Sicilia Único',
    description: 'Uno de los vinos más prestigiosos de España, con gran complejidad.',
    price: 89.99,
    imageUrl: '/images/wines/vega-sicilia.jpg',
    categoryId: '2',
    wineryId: '2',
    type: 'Tinto',
    year: 2015,
    alcoholContent: 14.0,
    stock: 25
  },
  {
    id: '3',
    name: 'Albariño Rías Baixas',
    description: 'Vino blanco fresco y aromático de las costas gallegas.',
    price: 18.50,
    imageUrl: '/images/wines/albarino.jpg',
    categoryId: '3',
    wineryId: '4',
    type: 'Blanco',
    year: 2022,
    alcoholContent: 12.5,
    stock: 75
  },
  {
    id: '4',
    name: 'Cava Codorníu',
    description: 'Espumoso tradicional con burbujas finas y persistentes.',
    price: 12.99,
    imageUrl: '/images/wines/codorniu.jpg',
    categoryId: '4',
    wineryId: '3',
    type: 'Espumoso',
    year: 2021,
    alcoholContent: 11.5,
    stock: 100
  },
  {
    id: '5',
    name: 'Jumilla Monastrell',
    description: 'Vino tinto potente de la región de Murcia.',
    price: 15.75,
    imageUrl: '/images/wines/jumilla.jpg',
    categoryId: '5',
    wineryId: '1',
    type: 'Tinto',
    year: 2020,
    alcoholContent: 14.5,
    stock: 60
  },
  {
    id: '6',
    name: 'Marqués de Riscal Verdejo',
    description: 'Vino blanco fresco y expresivo de la Rioja.',
    price: 12.50,
    imageUrl: '/images/wines/marques-riscal-verdejo.jpg',
    categoryId: '1',
    wineryId: '1',
    type: 'Blanco',
    year: 2023,
    alcoholContent: 12.5,
    stock: 40
  }
];

let mockCategories = [
  { id: '1', name: 'Rioja' },
  { id: '2', name: 'Ribera del Duero' },
  { id: '3', name: 'Rías Baixas' },
  { id: '4', name: 'Penedès' },
  { id: '5', name: 'Jumilla' }
];

let mockWineries = [
  { id: '1', name: 'Marqués de Riscal', region: 'Rioja' },
  { id: '2', name: 'Vega Sicilia', region: 'Ribera del Duero' },
  { id: '3', name: 'Codorníu', region: 'Penedès' },
  { id: '4', name: 'Rías Baixas Albariño', region: 'Galicia' }
];

let mockTypes = [
  { id: '1', name: 'Tinto', color: 'error' },
  { id: '2', name: 'Blanco', color: 'warning' },
  { id: '3', name: 'Rosado', color: 'secondary' },
  { id: '4', name: 'Espumoso', color: 'info' }
];

// Helper para generar IDs únicos
const generateId = () => Date.now().toString();

// API simulada para vinos
export const mockWinesApi = {
  getAll: async () => {
    await new Promise(resolve => setTimeout(resolve, 300)); // Simular delay
    return { data: { data: [...mockWines] } };
  },
  
  create: async (formData) => {
    await new Promise(resolve => setTimeout(resolve, 500));
    
    const newWine = {
      id: generateId(),
      name: formData.get('name'),
      description: formData.get('description'),
      price: parseFloat(formData.get('price')),
      categoryId: formData.get('categoryId'),
      wineryId: formData.get('wineryId'),
      type: formData.get('type'),
      year: formData.get('year') ? parseInt(formData.get('year')) : null,
      alcoholContent: formData.get('alcoholContent') ? parseFloat(formData.get('alcoholContent')) : null,
      stock: formData.get('stock') ? parseInt(formData.get('stock')) : 0,
      imageUrl: null // Las imágenes las manejamos por separado
    };
    
    mockWines.push(newWine);
    console.log('Created wine:', newWine);
    return { data: { success: true, data: newWine } };
  },
  
  update: async (id, formData) => {
    await new Promise(resolve => setTimeout(resolve, 500));
    
    const index = mockWines.findIndex(wine => wine.id === id);
    if (index === -1) {
      throw new Error('Vino no encontrado');
    }
    
    const originalWine = { ...mockWines[index] };
    
    const updatedWine = {
      ...mockWines[index],
      name: formData.get('name'),
      description: formData.get('description'),
      price: parseFloat(formData.get('price')),
      categoryId: formData.get('categoryId'),
      wineryId: formData.get('wineryId'),
      type: formData.get('type'),
      year: formData.get('year') ? parseInt(formData.get('year')) : null,
      alcoholContent: formData.get('alcoholContent') ? parseFloat(formData.get('alcoholContent')) : null,
      stock: formData.get('stock') ? parseInt(formData.get('stock')) : 0
    };
    
    mockWines[index] = updatedWine;
    console.log('Wine updated successfully:', {
      id,
      before: originalWine,
      after: updatedWine,
      wineryChanged: originalWine.wineryId !== updatedWine.wineryId
    });
    return { data: { success: true, data: updatedWine } };
  },
  
  delete: async (id) => {
    await new Promise(resolve => setTimeout(resolve, 300));
    
    const index = mockWines.findIndex(wine => wine.id === id);
    if (index === -1) {
      throw new Error('Vino no encontrado');
    }
    
    const deletedWine = mockWines.splice(index, 1)[0];
    console.log('Deleted wine:', deletedWine);
    return { data: { success: true } };
  }
};

// API simulada para categorías
export const mockCategoriesApi = {
  getAll: async () => {
    await new Promise(resolve => setTimeout(resolve, 200));
    return { data: { data: [...mockCategories] } };
  }
};

// API simulada para bodegas
export const mockWineriesApi = {
  getAll: async () => {
    await new Promise(resolve => setTimeout(resolve, 200));
    return [...mockWineries];
  }
};

// API simulada para tipos
export const mockTypesApi = {
  getAll: async () => {
    await new Promise(resolve => setTimeout(resolve, 200));
    return [...mockTypes];
  }
}; 